import React, { createContext, useCallback, useContext, useRef, useState } from 'react'

const ConfirmDialogContext = createContext(null)

export function ConfirmDialogProvider({ children }) {
  const [state, setState] = useState({ open: false, config: null })
  const resolveRef = useRef(null)

  const confirm = useCallback((config) => {
    return new Promise((resolve) => {
      resolveRef.current = resolve
      setState({ open: true, config })
    })
  }, [])

  const handleResolve = useCallback((value) => {
    setState({ open: false, config: null })
    if (resolveRef.current) {
      resolveRef.current(value)
      resolveRef.current = null
    }
  }, [])

  return (
    <ConfirmDialogContext.Provider
      value={{
        confirm,
        state,
        confirmAction: () => handleResolve(true),
        cancelAction: () => handleResolve(false),
      }}
    >
      {children}
    </ConfirmDialogContext.Provider>
  )
}

export function useConfirm() {
  const ctx = useContext(ConfirmDialogContext)
  if (!ctx) throw new Error('useConfirm must be used inside <ConfirmDialogProvider>')
  return ctx.confirm
}

// Internal hook for the dialog component itself to read state and resolve actions.
export function useConfirmDialogState() {
  const ctx = useContext(ConfirmDialogContext)
  if (!ctx) throw new Error('useConfirmDialogState must be used inside <ConfirmDialogProvider>')
  return ctx
}
